import { useAuth } from "../../../../context";
import { useMutation, useQuery } from "react-query";
import { DownstreamTransportationAndDistribution } from "../../../../api";

export const downstreamTransportationAndDistributionKeys = {
  items: () => ["downstreamTransportationAndDistributionItems"]
};

export function useGetDownstreamTransportationAndDistributionItems(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [
      ...downstreamTransportationAndDistributionKeys.items(),
      params.queryParams.page, params.queryParams.size, params.queryParams.sort
    ], () => callApi(DownstreamTransportationAndDistribution.getDownstreamTransportationAndDistributionItems, params),
    config);
}

export function useAddDownstreamTransportationAndDistributionItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(DownstreamTransportationAndDistribution.addDownstreamTransportationAndDistributionItems, {
      questionnaireId,
      data
    }), config);
}

export function useUpdateDownstreamTransportationAndDistributionItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data }) =>
    callApi(DownstreamTransportationAndDistribution.updateDownstreamTransportationAndDistributionItem, {
      questionnaireId,
      recordId,
      data
    }), config);
}

export function useDeleteDownstreamTransportationAndDistributionItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId }) =>
    callApi(DownstreamTransportationAndDistribution.deleteDownstreamTransportationAndDistributionItem, {
      questionnaireId,
      recordId
    }), config);
}

export function useImportDownstreamTransportationAndDistributionItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(DownstreamTransportationAndDistribution.importDownstreamTransportationAndDistributionItems, {
      questionnaireId,
      data
    }), config);
}

export function useDownloadDownstreamTransportationAndDistributionTemplate(config) {
  const { callApi } = useAuth();
  return useMutation(() => callApi(DownstreamTransportationAndDistribution.getDownstreamTransportationAndDistributionTemplate), config);
}